import { toUpper } from 'lodash';
import React from 'react';
import { GlobalToken } from 'antd';

const ConnectivityLight = ({
  connectivity,
  inMaintenance,
  Icon,
  token,
}: {
  connectivity: string;
  inMaintenance: boolean;
  Icon;
  token: GlobalToken;
}) => {
  if (inMaintenance) {
    return <Icon color={token.colorPrimary} />;
  }

  if (!connectivity || typeof connectivity !== 'string') {
    return <Icon />;
  }

  switch (toUpper(connectivity)) {
    case 'CONNECTED':
      return <Icon color={token.colorPrimary} />;
    case 'DISCONNECTED':
      return <Icon />;
    default:
      return <Icon />;
  }
};

export default ConnectivityLight;
